import { create } from "zustand";

import type { ErrorLogoSVG } from "@/components/global/PopupComponent/ErrorCustomPopupComponent/ErrorCustomPopupComponent";

export interface ErrorPopupMessage {
  title?: string | undefined;
  description?: string | undefined;
  refCode?: string | undefined;
}

export interface PropsErrorPopupInterface {
  buttonText?: string;
  showLogo?: boolean;
  logoSVG?: ErrorLogoSVG;
  showCloseButton?: boolean;
  handleButton?: () => void;
  handleOpen?: () => void;
}

type State = {
  isOpenLoading: boolean;
  isOpenErrorPopup: boolean;
  errorPopupMessage: ErrorPopupMessage;
  isSearchLoading: boolean;
  propsErrorPopup: PropsErrorPopupInterface;
};
type Actions = {
  setIsOpenLoading: (trigger: boolean) => void;
  setIsOpenErrorPopup: (trigger: boolean) => void;
  setErrorPopupMessage: (trigger: ErrorPopupMessage) => void;
  setIsSearchLoading: (state: boolean) => void;
  setPropsErrorPopup: (trigger: PropsErrorPopupInterface) => void;
};
export const useLoadingStore = create<State & Actions>((set) => ({
  isOpenLoading: false,
  isOpenErrorPopup: false,
  setIsOpenLoading: (trigger: boolean) =>
    set(() => ({ isOpenLoading: trigger })),
  setIsOpenErrorPopup: (trigger: boolean) =>
    set(() => ({ isOpenErrorPopup: trigger })),
  errorPopupMessage: {
    title: undefined,
    description: undefined,
    refCode: undefined,
  },
  setErrorPopupMessage: (trigger: ErrorPopupMessage) =>
    set(() => ({ errorPopupMessage: trigger })),
  isSearchLoading: true,
  setIsSearchLoading: (state: boolean) =>
    set(() => ({ isSearchLoading: state })),
  propsErrorPopup: {
    buttonText: undefined,
    showLogo: undefined,
    showCloseButton: undefined,
  },
  setPropsErrorPopup: (trigger: PropsErrorPopupInterface) =>
    set(() => ({ propsErrorPopup: trigger })),
}));
